import { createRequest } from '@/api/fetch';
import auth0 from '@/auth/auth0Plugin';
import store from '@/store';
import { FeaturedPlacement } from '@/types-featured-placement';
import { captureError } from '@smg-real-estate/browser-rum';

function getErrorMessage(error: unknown): string {
  return error instanceof Error ? error.message : 'Unknown error';
}

const featuredPlacementEndpointUrl = `${import.meta.env.VUE_APP_AGENCY_DIRECTORY_BASE_URL}/featured-placements`;

export async function getFeaturedPlacementByAPI(): Promise<FeaturedPlacement> {
  try {
    const authToken = await auth0.getAccessTokenSilently({
      cacheMode: 'on',
      authorizationParams: {
        selectedCustomerId: store.getters.getActiveAgencyId,
        selectedPersonId: store.getters.getActiveAgencyPersonId,
      },
    });

    const response = await fetch(featuredPlacementEndpointUrl, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    });

    if (!response.ok) {
      throw new Error(`Failed to get featured placement with response code: ${response.status}`);
    }

    return (await response.json()).data as FeaturedPlacement;
  } catch (error) {
    throw new Error(`Failed to fetch featured placement: ${getErrorMessage(error)}`);
  }
}

export const putFeaturedPlacement = async (
  featuredPlacementsPayload: FeaturedPlacement,
): Promise<any> => {
  try {
    const response = await createRequest({ method: 'PUT', credentials: 'same-origin' })(
      featuredPlacementEndpointUrl,
      JSON.stringify(featuredPlacementsPayload),
    );

    if (!response.ok) {
      throw new Error(
        `Failed to put featured placements data with response code: ${response.status}`,
      );
    }

    return true;
  } catch (error) {
    captureError(new Error(error.message));
    throw error;
  }
};
